export default {
  storyboardScreens: [
    {
      imageFile: "05a_Buy_Persona.jpg",
      title: "Smart Clienteling",
      text:
        "Click NEXT to learn how Jon uses customer insights to close sales and meet targets.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05a",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "05b_Buy_651.jpg",
      title: "Smart Clienteling",
      text:
        "Jon’s clienteling app notifies him that Lisa is coming in to try on one of the new Fall Promo dresses. He can see that she has been looking at the dress for a while now. ",
      coordinates: { left: "627", top: "244", right: "134", bottom: "305" },
      screenId: "B05b",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "05c_Buy_651.jpg",
      title: "Smart Clienteling",
      text:
        "Jon takes a closer look at the dress to get more familiar with it.",
      coordinates: { left: "639", top: "279", right: "272", bottom: "221" },
      screenId: "B05c",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "05d_Buy_651.jpg",
      title: "Smart Clienteling",
      text:
        "He also looks at some accessories that complement the dress, which he can show Lisa when she arrives.",
      coordinates: { left: "628", top: "114", right: "342", bottom: "513" },
      screenId: "B05d",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "05e_Buy_Scene.jpg",
      title: "Buying the Dress",
      text: "30 minutes later…",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05e",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "05f_Buy_Scene.jpg",
      title: "Buying the Dress",
      text: "Jon greets Lisa when she arrives at the store.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05f",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "05g_Buy_Scene.jpg",
      title: "Buying the Dress",
      text:
        "The dress looks even better in the store, and Lisa goes to try it on.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05g",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "05h_Buy_Scene.jpg",
      title: "Buying the Dress",
      text:
        "Jon and Lisa hit it off. Jon sells the dress, as well as several accessories to complete the look.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05h",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "05i-Buy_Callidus01.jpg",
      title: "Employee Sales Tracking",
      text:
        "After his shift, Jon leaves the store to meet some friends for dinner.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05i",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "05j-Buy_Callidus02.jpg",
      title: "Employee Sales Tracking",
      text:
        "He’s motivated by the day’s sales and wants to see his commissions for the week.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05j",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "05k-Buy_Callidus03.jpg",
      title: "Employee Sales Tracking",
      text:
        "He drills down further and is thrilled to see that he is now at the top of the leaderboard!",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "B05k",
      hasNext: true,
      highlightPosition: "Top-Right"
    }
  ]
};
